<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :items-per-page="15"
            dense
            >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>PO Control</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />


                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="body-1 text-center">Anda akan menghapus data ini ?</v-card-title>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                <v-spacer />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="dialogView" max-width="800px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Detail PO Control</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <strong>Outlet:</strong> {{ viewedItem.outlet_name || '-' }}
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <strong>Volume:</strong> {{ viewedItem.size || '-' }}
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <strong>Delivery Date:</strong> {{ viewedItem.delivery_date || '-' }}
                                        </v-col>
                                        <v-col cols="12" sm="6" v-if="viewedItem.delivery_date2">
                                            <strong>Actual Delivery Date:</strong> {{ viewedItem.delivery_date2 || '-' }}
                                        </v-col>
                                        <v-col cols="12" sm="6" v-if="viewedItem.expired_date">
                                            <strong>Expired Date:</strong> {{ viewedItem.expired_date || '-' }}
                                        </v-col>
                                        <v-col cols="12" sm="6" v-if="viewedItem.arrival_date">
                                            <strong>Arrival Date:</strong> {{ viewedItem.arrival_date || '-' }}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-data-table
                                                :headers="detailHeaders"
                                                :items="detailItems"
                                                :items-per-page="10"
                                                dense
                                                class="elevation-1"
                                            >
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeView">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
                <div class="">
                    <v-row class="mx-5">
                        <v-col cols="1" class="new-compact-form">Start Date</v-col>
                        <v-col>
                            <v-menu v-model="startDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="startDate" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                                </template>
                                <v-date-picker v-model="startDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="1" class="new-compact-form">End Date</v-col>
                        <v-col>
                            <v-menu v-model="endDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="endDate" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                                </template>
                                <v-date-picker v-model="endDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col>
                            <v-spacer></v-spacer>
                            <v-btn depressed color="primary" @click="fetchData">Run</v-btn>
                        </v-col>

                    </v-row>
            </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small @click="viewItem(item)" style="cursor: pointer;">
                    mdi-eye
                </v-icon>
                <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="fetchData">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            dialogDelete: false,
            dialogView: false,
            headers: [
                { text: 'Outlet', value: 'outlet_name' },
                { text: 'Volume', value: 'size', sortable: true },
                { text: 'Date', value: 'delivery_date', sortable: true },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            detailHeaders: [
                { text: 'Product Code', value: 'variant_code', sortable: true },
                { text: 'Product Name', value: 'variant_name', sortable: true },
                { text: 'Quantity Ordered', value: 'quantity_ordered', sortable: true },
                { text: 'Quantity Delivered', value: 'quantity_delivered', sortable: true },
                { text: 'Quantity After Adjustment', value: 'quantity_after_adjustment', sortable: true }
            ],
            items: [],
            detailItems: [],
            editedIndex: -1,
            editedItem: {},
            viewedItem: {},
            defaultItem: {},
            reqRule: [v => !!v || 'Harus diisi!'],
            valid: true,
            startDateMenu: false,
            endDateMenu: false,
            startDate: new Date().toISOString().substr(0, 10),
            endDate: new Date().toISOString().substr(0, 10),
        }),

        computed: {
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            dialogDelete(val) {
                val || this.closeDelete();
            },
            dialogView(val) {
                val || this.closeView();
            },
        },

        created() {
        },

        methods: {
            async fetchData() {
                this.items = (await this.$store.dispatch('getObjs',{apidomain:'others/pocontrol/ALL/' + this.startDate + '/', parameter:this.endDate})).data
            },

            async viewItem(item) {
                this.viewedItem = Object.assign({}, item);
                this.dialogView = true;
                
                try {
                    const outlet_code = item.outlet_code;
                    const delivery_date = item.delivery_date;
                    const size = item.size;
                    
                    const response = await this.$store.dispatch('getObjs', {
                        apidomain: `others/pocontrol-detail/${outlet_code}/${delivery_date}/`,
                        parameter: size
                    });
                    
                    this.detailItems = response.data || [];
                } catch (error) {
                    console.error('Error fetching PO details:', error);
                    this.detailItems = [];
                }
            },

            deleteItem(item) {
                this.editedIndex = this.items.indexOf(item);
                this.editedItem = Object.assign({}, item);
                console.log(this.editedItem)
                this.dialogDelete = true;
            },

            async deleteItemConfirm() {
                const outlet_code = this.editedItem.outlet_code
                const delivery_date = this.editedItem.delivery_date
                const size = this.editedItem.size
                let response = (await this.$store.dispatch('getObjs',{apidomain:'others/deletepo/'+outlet_code+'/' + delivery_date + '/', parameter:size})).data
                if (response) this.items.splice(this.editedIndex, 1);
                this.closeDelete();
            },

            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
                this.resetForm();
            },
            closeDelete() {
                this.dialogDelete = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
                this.resetForm();
            },
            closeView() {
                this.dialogView = false;
                this.$nextTick(() => {
                    this.viewedItem = Object.assign({}, this.defaultItem);
                    this.detailItems = [];
                });
            },
            resetForm() {
                this.fetchData();
            }
        }
    }
</script>